import React from 'react';
import { Link } from 'react-router-dom';
import { BellIcon, HelpCircleIcon, MenuIcon, SearchIcon } from 'lucide-react';
interface User {
  name: string;
  company: string;
  avatar: string;
}
interface DashboardHeaderProps {
  user: User;
  onMenuClick: () => void;
}
export function DashboardHeader({
  user,
  onMenuClick
}: DashboardHeaderProps) {
  return <header className="bg-white shadow-sm sticky top-0 z-10" data-id="element-162">
      <div className="px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between" data-id="element-163">
        {/* Left: Menu button (mobile) and search */}
        <div className="flex items-center" data-id="element-164">
          <button type="button" className="md:hidden mr-4 text-gray-500 hover:text-gray-700" onClick={onMenuClick} data-id="element-165">
            <MenuIcon size={24} data-id="element-166" />
          </button>
          <div className="relative hidden md:block max-w-xs w-full" data-id="element-167">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-168">
              <SearchIcon size={16} className="text-gray-400" data-id="element-169" />
            </div>
            <input type="text" placeholder="Rechercher des appels d'offres..." className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md text-sm placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500" data-id="element-170" />
          </div>
        </div>
        {/* Right: Notifications and profile */}
        <div className="flex items-center space-x-4" data-id="element-171">
          <button type="button" className="p-1 text-gray-500 hover:text-gray-700 relative" data-id="element-172">
            <BellIcon size={20} data-id="element-173" />
            <span className="absolute top-0 right-0 block h-2 w-2 rounded-full bg-red-500 transform translate-x-1/4 -translate-y-1/4" data-id="element-174"></span>
          </button>
          <button type="button" className="p-1 text-gray-500 hover:text-gray-700" data-id="element-175">
            <HelpCircleIcon size={20} data-id="element-176" />
          </button>
          <div className="flex items-center" data-id="element-177">
            <div className="hidden md:block mr-3 text-right" data-id="element-178">
              <div className="text-sm font-medium text-gray-900" data-id="element-179">
                {user.name}
              </div>
              <div className="text-xs text-gray-500" data-id="element-180">{user.company}</div>
            </div>
            <div className="h-8 w-8 rounded-full bg-gray-200 flex-shrink-0 overflow-hidden" data-id="element-181">
              <img src={user.avatar} alt={user.name} className="h-full w-full object-cover" data-id="element-182" />
            </div>
          </div>
        </div>
      </div>
    </header>;
}